module.exports = __webpack_public_path__ + "img/third.93f42ae4.svg";